



















import { Component, Prop, Watch } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-select',
  components: {},
})
export default class DisplayFieldSelect extends mixins(AbstractDisplayField) {
  selectValue: string | number = null;

  mounted() {
    this.selectValue = this.value;
  }

  get saveOnChange(): boolean {
    return this.fieldConfig.saveOnChange ?? false;
  }

  get entity(): string {
    return this.fieldConfig.entity;
  }

  get options(): object[] {
    return this.fieldConfig.configOptions;
  }

  get savePath(): string {
    return this.fieldConfig.savePath;
  }

  onChange() {
    if (this.saveOnChange && this.entity && this.item?.id) {
      const path = this.$bpcApiRouteHelper.getEntityPath(this.entity) + '/' + this.item.id;
      const payload: object = { id: this.item.id };
      payload[this.fieldConfig.key] = this.selectValue;

      this.$bpcApi.patch(path, payload).subscribe(
        res => {
          this.$emit('saved-on-change', res);
          this.$root.$emit('saved-on-change-from-table', res);
        },
        error => {
          this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_form_action' });
        },
      );
    }
  }
}
